import React from "react";
import { Card, Col } from "react-bootstrap";
import Skeleton from "../../../../components/skeleton";

const TopPerformingContentsSkeleton = () => {
  return (
    <Card data-aos="fade-up" data-aos-delay="500">
      <Card.Body>
        <Col md={12} className="mb-3 d-flex justify-content-between">
          <h5 className="mb-1 fw-semibold">Top Performing</h5>
        </Col>

        <div className="d-flex gap-3 justify-content-between align-items-center">
          {[...Array(3)].map((_, index) => {
            return (
              <div
                className="d-flex border border-1 p-3 gap-3 rounded-3 w-100"
                key={`top-performing-${index}`}
              >
                <div>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={200}
                    className="h-100"
                  />
                </div>
                <div>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                    // className="mb-2"
                  />
                  <Skeleton
                    variant="text"
                    width={200}
                    height={20}
                    className="w-100"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </Card.Body>
    </Card>
  );
};

export default TopPerformingContentsSkeleton;
